export default {
    data() {
        return {
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
        }
    },

    computed: {
        isMobile() {
            return this.windowWidth < 960
        },
        isTablet() {
            return this.windowWidth >= 960 && this.windowWidth < 1400
        },
        isComputer() {
            return this.windowWidth >= 1400
        },
        isSmallMobile() {
            return this.windowWidth < 600
        }
    },

    created() {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this._handleResize)
        }
    },

    beforeDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this._handleResize)
        }
    },

    methods: {
        _handleResize() {
            this.windowWidth = window.innerWidth
            this.windowHeight = window.innerHeight
        }
    }
}
